<div class="lum-modal shipping-label-details__wrapper">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">{{ pageTitle }}</span>
  </div>
  <div class="lum-modal__body">
    <mat-tab-group [selectedIndex]="selectedTabIndex" animationDuration="0ms">
      <mat-tab>
        <ng-container *ngIf="(loading$ | async) === false; else loader">
          <div class="form-group" *ngIf="this.data?.withPackingSlip">
            <label>Packing Slip Page Size</label>
            <mat-select
              class="lum-select"
              placeholder="Select page size"
              [(value)]="packingSlipPageSize"
            >
              <mat-option [value]="ePageSize.A4">A4 (4x6)</mat-option>
              <mat-option [value]="ePageSize.A6">A6 (8.5x11)</mat-option>
            </mat-select>
          </div>
          <table
            class="lum-table lum-table--classic"
            *ngIf="shipment?.id; else noRecords"
          >
            <thead>
              <tr>
                <th>Carrier</th>
                <th class="text-center">Packages</th>
                <th class="text-center">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ shipment?.shippingCarrier?.name || shipment?.carrierCode }}
                </td>
                <td class="text-center">1</td>
                <td class="text-center">
                  {{ shipment?.shipmentCost | currency }}
                </td>
              </tr>
              <tr>
                <td class="font-bold">Total</td>
                <td class="font-bold text-center">{{ total?.packages }}</td>
                <td class="font-bold text-center">
                  {{ total?.shipmentCost | currency }}
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </mat-tab>
      <mat-tab>
        <div class="mb-2">
          <span class="font-bold">Tracking Number: </span>
          {{ shipment?.trackingNumber }}
        </div>
        <div
          class="pdf-viewer__container"
          *ngIf="(loadingPdf$ | async) === false; else loader"
        >
          <div class="pdf-viewer__toolbar">
            <button mat-icon-button (click)="onRotate(-90)">
              <mat-icon>rotate_left</mat-icon>
            </button>
            <button mat-icon-button (click)="onRotate(90)">
              <mat-icon>rotate_right</mat-icon>
            </button>
            <button mat-icon-button (click)="onZoom(0.1)">
              <mat-icon>zoom_in</mat-icon>
            </button>
            <button mat-icon-button (click)="onZoom(-0.1)">
              <mat-icon>zoom_out</mat-icon>
            </button>
            <button mat-icon-button (click)="onDownload()">
              <mat-icon>cloud_download</mat-icon>
            </button>
            <button mat-icon-button (click)="onPrint()">
              <mat-icon>print</mat-icon>
            </button>
          </div>
          <pdf-viewer
            #pdfViewer
            style="height: 500px; background: #413f43"
            [src]="pdfSrc"
            [render-text]="true"
            [original-size]="false"
            [rotation]="rotationAngle"
            [original-size]="true"
            [zoom]="zoomValue"
            (after-load-complete)="onPdfLoaded($event)"
          ></pdf-viewer>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="lum-modal__footer">
    <button
      mat-button
      type="button"
      class="lum-button lum-button--secondary ml-auto mr-2"
      (click)="onClose()"
    >
      Cancel
    </button>
    <ng-container *ngIf="shipment?.id">
      <button
        mat-button
        type="button"
        class="lum-button lum-button--secondary"
        *ngIf="shipment?.id && !selectedTabIndex"
        (click)="onCreateLabel()"
      >
        Create Label
      </button>
    </ng-container>
  </div>
</div>

<ng-template #loader>
  <div class="w-100">
    <mat-spinner diameter="20" class="mx-auto"></mat-spinner>
  </div>
</ng-template>

<ng-template #noRecords>
  <div class="text-center p-4">
    <h3>No records available.</h3>
  </div>
</ng-template>
